// FilterBar.jsx
import React, { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { Field, reduxForm, formValueSelector } from "redux-form";
import { useSelector } from "react-redux";
import MultiSelectDagen from "../../../../../Components/Forms/multiselect";
import { renderselect } from "../../../../../Components/Forms/renders";
import CheckboxGroup from "../../../../../Components/Forms/CheckboxGroup";

const FilterBar = ({ handleSubmit, initialize }) => {
  const [showFilters, setShowFilters] = useState(false);
  const selector = formValueSelector("filterForm");
  const formValues = useSelector((state) => selector(state, "categorien", "status", "geboekt"));

  // initialiseren uit cookie
  useEffect(() => {
    const saved = Cookies.get("filters");
    if (saved) {
      initialize(JSON.parse(saved));
    }
  }, [initialize]);

  // sla live wijzigingen direct op in cookie
  useEffect(() => {
    if (formValues) {
      Cookies.set("filters", JSON.stringify(formValues), { expires: 7 });
    }
  }, [formValues]);

  // bepaal actieve badge-items
  const activeEntries = formValues
    ? Object.entries(formValues).filter(([_, value]) => {
        if (Array.isArray(value)) return value.length > 0;
        return value != null && value !== "";
      })
    : [];

  return (
    <div className="filter-bar-container">
      {/* Desktop toggle */}
      <button type="button" className="filter-toggle-btn d-none d-md-block" onClick={() => setShowFilters((prev) => !prev)}>
        {showFilters ? "Verberg filters" : "Toon filters"}
      </button>

      {/* Actieve filters (label + badges naast elkaar) */}
      {activeEntries.length > 0 && (
        <div className="active-filters mb-3 d-flex align-items-center gap-3">
          <strong>Actieve filters:</strong>
          <div className="badges d-flex flex-wrap gap-2">
            {activeEntries.map(([key, value]) => {
              const label = Array.isArray(value) ? value.join(", ") : value;
              return (
                <span key={key} className="badge">
                  {key}: {label}
                </span>
              );
            })}
          </div>
        </div>
      )}

      {/* Mobiele toggle */}
      <button className="filter-toggle-mobile d-md-none" type="button" onClick={() => setShowFilters((prev) => !prev)}>
        {showFilters ? "Verberg filters" : "Toon filters"}
      </button>

      {/* Filters */}
      <div className={`filters ${showFilters ? "open" : ""}`}>
        <form onSubmit={handleSubmit(() => {})}>
          <div className="row g-3">
            <div className="col-12 col-md-6 col-lg-4">
              <Field name="categorien" component={MultiSelectDagen} options={["VVV", "Pin", "Contant", "Online"]} label="Categorieën" />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
          <Field name="status" component={CheckboxGroup} options={["Ja"]} label="Stroompunt ingeschakeld" />
            </div>
            <div className="col-12 col-md-6 col-lg-4">
              <Field name="geboekt" component={CheckboxGroup} options={["Ja"]} label="Heeft boeking" />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default reduxForm({
  form: "filterForm",
  enableReinitialize: true,
})(FilterBar);
